import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { Icon } from 'ui';

const DropdownItem = forwardRef(
  (
    {
      icon,
      children,
      onClick,
      active,
      disabled,
      type = 'button',
    }: {
      icon?: UIIconName;
      children: React.ReactNode;
      onClick?: () => void;
      active?: boolean;
      disabled?: boolean;
      type?: 'button' | 'submit';
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      role="menuitem"
      className={classNames(
        `group flex w-full items-center whitespace-nowrap px-4 py-2 text-left text-sm`,
        active && !disabled && 'bg-primary-700 text-white',
        disabled && !active && 'cursor-not-allowed text-gray-400',
        !active && !disabled && 'text-gray-700 hover:bg-gray-100 hover:text-gray-900',
      )}
      onClick={onClick}
    >
      {icon && <Icon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" name={icon} />}
      <div className="contents">{children}</div>
    </button>
  ),
);

export default DropdownItem;
